export default "__VITE_ASSET__C9Q2gjYB__"